import React, { useState, useEffect } from "react";
import moment from "moment";
import { Row, Col, Card, Form, Input, Button, DatePicker, Spin } from "antd";
import { BasicFormWrapper } from "../../styled";
import { formatSQLDate } from "../../../utils/common";

import { useHistory } from "react-router-dom";

import { useMutation } from "@apollo/client";
import { UPDATE_SERVICE_ACTION } from "../../../graphql/AdminMutations";
import displayNotification from "../../reservation/admin/notification/notification";

import FeatherIcon from "feather-icons-react";
import { SelectPaymentType } from "../../../components/customSelect/selectPaymentType";
import sendInvoiceEmail from "./Invoice/email";
import {
  approveAyvensOrder,
  checkAyvensVehicle,
  createAyvensOrder,
} from "../../../Api/ayvens";

const InfoFormRight = (props) => {
  const dateFormat = "DD.MM.YYYY";
  const history = useHistory();
  const {
    t,
    data,
    graphqlVariables,
    setStatusChange,
    invoiceData,
    additionalInfo,
  } = props;
  const [code, setCode] = useState("");
  const [status, setStatus] = useState(data?.status);
  const [paymentType, setPaymentType] = useState("bank");
  const [statusName, setStatusName] = useState(
    t("serviceActions.tableList.statuses." + data?.status)
  );
  let carOwnerCode = data?.carOwner?.code;
  const emailDisableMessage =
    "Nie je možné zaslať dokumenty, zákaník nemá vyplnenú emailovú adresu.";

  let canDisplayEmailButtons = false;
  if (data?.carOwner?.invoice_emails) {
    canDisplayEmailButtons = true;
  }
  const [canSetCode, setCanSetCode] = useState(
    status === "open" ? true : false
  );
  const [canApprove, setCanApprove] = useState(false);
  const [issueDate, setIssueDate] = useState(moment().format("YYYY-MM-DD"));
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [invoiceSendStatus, setInvoiceSendStatus] = useState(false);
  const [invoiceSendStatusEcon, setInvoiceSendStatusEcon] = useState(false);
  const [ayvensResult, setAyvensResult] = useState(null);
  const [ayvensOrderStatus, setAyvensOrderStatus] = useState(true);
  const [ayvensResponse, setAyvensResponse] = useState(null);
  const [showAyvensDocument, setShowAyvensDocument] = useState(false);
  const [enableAyvensFunctions, setEnableAyvensFunctions] = useState(true);
  const [displayDeclinedInfoMessage, setDisplayDeclinedInfoMessage] = useState(
    false
  );

  const [ayvensVehicleInfo, setAyvensVehicleInfo] = useState(() => {
    try {
      return data?.ayvens_response ? JSON.parse(data.ayvens_response) : null;
    } catch (error) {
      console.error("Error parsing ayvens_response:", error);
      return null;
    }
  });
  const [ayvensApprovalResponse, setAyvensApprovalResponse] = useState(() => {
    try {
      return data?.ayvens_approval_response
        ? JSON.parse(data.ayvens_approval_response)
        : null;
    } catch (error) {
      console.error("Error parsing ayvens_approval_response:", error);
      return null;
    }
  });
  const [ayvensOrderApprovedStatus, setAyvensOrderApprovedStatus] = useState(
    false
  );
  const [triggerUpdateItem] = useMutation(UPDATE_SERVICE_ACTION, {
    variables: graphqlVariables,
  });

  useEffect(() => {
    if (data?.invoiceSendStatus) {
      setInvoiceSendStatus(true);
    }
    if (data?.invoiceSendStatusEcon) {
      setInvoiceSendStatusEcon(true);
    }
  }, [data?.invoiceSendStatus]);

  useEffect(() => {
    if (
      data?.ayvens_order_status === "created" ||
      data?.ayvens_order_status === "approved" ||
      data?.ayvens_order_status === "approved_with_over_limit" ||
      data?.items.length === 0 ||
      data?.ayvens_order_status === "declined"
    ) {
      setAyvensOrderStatus(false);
    } else {
      setAyvensOrderStatus(true);
    }
    if (data?.ayvens_order_status === "approved_with_over_limit") {
      setShowAyvensDocument(true);
    } else {
      setShowAyvensDocument(false);
    }
    if (data?.ayvens_order_status === "created") {
      setAyvensOrderApprovedStatus(true);
    } else {
      setAyvensOrderApprovedStatus(false);
    }
    if (data?.ayvens_contract_number === null) {
      setAyvensOrderStatus(false);
    }
    if (data?.ayvens_response !== null) {
      setAyvensResponse(data?.ayvens_response);
    }
    if (data?.ayvens_order_status === "declined") {
      setDisplayDeclinedInfoMessage(true);
      // do not overwrite status when approved_manually / invoiced / sent (show full UI for those)
      const keepStatus =
        data?.status === "approved_manually" ||
        data?.status === "invoiced" ||
        data?.status === "sent";
      if (!keepStatus) {
        setStatus("declined");
      }
      setCanSetCode(true); // allow entering authorization_code when declined
    } else {
      setDisplayDeclinedInfoMessage(false);
    }
  }, [data]);

  const handleDownloadInvoice = async () => {
    setSpinnerStatus(true);
    const pdfFile = await sendInvoiceEmail(
      graphqlVariables.id,
      "internal",
      "download"
    );
    const file = new Blob([pdfFile], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(file);
    setSpinnerStatus(false);
    window.open(fileURL);
  };

  const handleSendInvoice = async (type) => {
    setSpinnerStatus(true);
    const confirm = window.confirm("Naozaj chcete odoslať faktúru emailom?");
    if (confirm) {
      const result = await sendInvoiceEmail(graphqlVariables.id, type, "email");
      let messageType = "success";
      const message = "Email info";
      const toWho = type === "internal" ? "ekonómke" : "zákazníkovi";
      let desc = `Faktúra bola odoslaná ${toWho}`;
      if (!result) {
        messageType = "error";
        desc = "Chyba pri odosielaní faktúry";
      } else {
        if (type === "customer") {
          let variables = { ...graphqlVariables };
          variables.invoiceSendStatus = true;

          triggerUpdateItem({ variables }).then(({ data }) => {
            const response = data?.updateServiceAction;
            if (response.sucessful) {
              setInvoiceSendStatus(true);
            }
          });
        }
      }
      setSpinnerStatus(false);
      displayNotification(messageType, message, desc);
    }
    setSpinnerStatus(false);
  };

  const handleIssueDateChange = (date) => {
    const value = moment(date).format("YYYY-MM-DD");
    setIssueDate(value);
  };

  const handleGetVehicleAndConditions = async (e) => {
    e.preventDefault();
    setSpinnerStatus(true);
    const result = await checkAyvensVehicle(
      additionalInfo?.licencePlate,
      additionalInfo?.serviceId
    );
    setAyvensResult(JSON.stringify(result));
    if (result.code === 400) {
      displayNotification("error", "Chyba", "Ayvens vozidlo nebolo nájdené");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      window.location.reload();
    }
    setSpinnerStatus(false);
  };

  const handleApproveAyvensOrder = async (e) => {
    e.preventDefault();
    setSpinnerStatus(true);
    const result = await approveAyvensOrder(additionalInfo?.serviceId);

    // approvalNumber = "null";
    // ayvensStatus = true;
    // code = 200;
    // message = "Objednávka bola zamietnutá";
    // orderApprovalStatus = 0;
    // overLimitProtocol = null;
    // status = "OK";
    if (result.code === 400 || result.orderApprovalStatus === 0) {
      displayNotification("error", "Chyba", result?.message);
      setStatus("declined");
    } else {
      displayNotification(
        "success",
        "OK",
        "Objednávka v Ayvens bola schválená"
      );
      setAyvensOrderApprovedStatus(false);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
    setSpinnerStatus(false);
  };
  const handleCreateAyvensOrder = async (e) => {
    e.preventDefault();
    setSpinnerStatus(true);

    // Validate serviceItems array and codes
    const serviceItems = additionalInfo?.serviceItems;
    if (!Array.isArray(serviceItems) || serviceItems.length === 0) {
      displayNotification("error", "Chyba", "Kód položky je povinný");
      setSpinnerStatus(false);
      return;
    }

    // Check if every item has a valid code
    const hasValidCode = (code) => {
      return typeof code === "string" && code.trim().length > 0;
    };

    const hasInvalidItems = serviceItems.some(
      (item) => !hasValidCode(item.code)
    );

    if (hasInvalidItems) {
      displayNotification("error", "Chyba", "Kód položky je povinný");
      setSpinnerStatus(false);
      return;
    }

    const result = await createAyvensOrder(additionalInfo?.serviceId);
    // return false;
    if (result.code >= 400) {
      displayNotification("error", "Chyba", result?.message);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 2000);
    } else {
      setAyvensOrderStatus(false);
      setAyvensOrderApprovedStatus(true);
      displayNotification(
        "success",
        "OK",
        "Objednávka v Ayvens bola vytvorená"
      );
    }
    setSpinnerStatus(false);
  };

  const handleGenerateInvoice = () => {
    const effective = status ?? data?.status;
    if (effective !== "approved" && effective !== "approved_manually") return;
    let variables = { ...graphqlVariables };
    variables.invoiced = true;
    variables.invoice_issue_date = issueDate;
    variables.payment_type = paymentType;

    triggerUpdateItem({ variables }).then(({ data }) => {
      const response = data?.updateServiceAction;
      let type = "success";
      const message = t("backend.notifications.update");
      let desc = t("backend.notifications.success.recordUpdate");
      if (response.sucessful) {
        setStatus("invoiced");
      } else {
        type = "error";
        desc = t("backend.notifications.error.recordUpdate");
      }
      displayNotification(type, message, desc);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  };
  const onFinish = (values) => {
    let variables = { ...graphqlVariables };
    if (values.mileage) variables.mileage = Number(values.mileage);
    if (values.note) variables.note = values.note;
    if (values.authorization_code) {
      variables.authorization_code = values.authorization_code;
      if (status === "declined" && data?.ayvens_order_status === "declined") {
        variables.status = "approved_manually";
      } else if (status !== "declined") {
        variables.status = "approved";
      }
    }
    triggerUpdateItem({ variables }).then(({ data }) => {
      const response = data?.updateServiceAction;
      let type = "success";
      const message = t("backend.notifications.update");
      let desc = t("backend.notifications.success.recordUpdate");
      if (response.sucessful) {
        // dispatch(deleteServiceAction(id))
        // setStatus('approved')
        // setStatusName('Schválený')
        // setStatusChange('approved')
        // setCanSetCode(false)
      } else {
        type = "error";
        desc = t("backend.notifications.error.recordUpdate");
      }
      displayNotification(type, message, desc);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  };

  const effectiveStatus = status ?? data?.status;
  const isApproved =
    effectiveStatus === "approved" || effectiveStatus === "approved_manually";

  let formTitle = "";
  if (data?.invoice_number) {
    formTitle =
      t("serviceActions.detail.invoice.number") +
      ":" +
      data?.invoice_number +
      " | " +
      t("serviceActions.detail.invoice.dateOfIssue") +
      ":" +
      moment(data?.invoice_issue_date).format("DD.MM.YYYY") +
      " | " +
      t("serviceActions.detail.invoice.dueDate") +
      ":" +
      moment(data?.invoice_due_date).format("DD.MM.YYYY");
  }
  const overLimitProtocolData = ayvensApprovalResponse?.overLimitProtocol;

  const handleDownloadOverLimitProtocol = () => {
    if (!overLimitProtocolData) return;

    try {
      // Convert base64 to binary data
      const binaryString = atob(overLimitProtocolData);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      // Create blob and download
      const blob = new Blob([bytes], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Error downloading over limit protocol:", error);
      displayNotification("error", "Chyba", "Nepodarilo sa stiahnuť protokol");
    }
  };
  return (
    <>
      {spinnerStatus && (
        <div className="spin">
          <Spin />
        </div>
      )}
      <BasicFormWrapper className="mb-25">
        <Form name="sDash_grid-form" layout="horizontal" onFinish={onFinish}>
          <Card
            title={formTitle}
            extra={
              <>
                {carOwnerCode &&
                  carOwnerCode === "ayvens" &&
                  status === "open" &&
                  enableAyvensFunctions && (
                    <>
                      <Button
                        className="ant-btn btn-invoice"
                        onClick={(e) => handleGetVehicleAndConditions(e)}
                        disabled={!enableAyvensFunctions}
                      >
                        {t(
                          "serviceActions.detail.ayvens.getVehicleAndConditions"
                        )}
                      </Button>

                      {ayvensOrderStatus && (
                        <Button
                          className="ant-btn btn-invoice"
                          onClick={(e) => handleCreateAyvensOrder(e)}
                          disabled={
                            !enableAyvensFunctions || !ayvensOrderStatus
                          }
                        >
                          {t("serviceActions.detail.ayvens.createOrder")}
                        </Button>
                      )}
                      {ayvensOrderApprovedStatus && (
                        <Button
                          className="ant-btn btn-invoice"
                          onClick={(e) => handleApproveAyvensOrder(e)}
                          disabled={
                            !enableAyvensFunctions || !ayvensOrderApprovedStatus
                          }
                        >
                          {t("serviceActions.detail.ayvens.approveOrder")}
                        </Button>
                      )}
                    </>
                  )}

                {showAyvensDocument &&
                  overLimitProtocolData &&
                  enableAyvensFunctions && (
                    <Button
                      className="ant-btn btn-invoice"
                      onClick={() => handleDownloadOverLimitProtocol()}
                      disabled={!enableAyvensFunctions}
                    >
                      <FeatherIcon icon="file-text" size={14} />
                      &nbsp; Prekročenie limitu - Protokol
                    </Button>
                  )}

                {status === "open" && (
                  <>
                    {canApprove && (
                      <Button htmlType="submit" className="ant-btn btn-invoice">
                        {t("serviceActions.detail.approve")}
                      </Button>
                    )}
                    <Button
                      htmlType="submit"
                      className="ant-btn ant-btn-primary"
                    >
                      {t("serviceActions.detail.updateInfo")}
                    </Button>
                  </>
                )}
                {status === "declined" &&
                  data?.ayvens_order_status === "declined" && (
                    <Button
                      htmlType="submit"
                      className="ant-btn ant-btn-primary"
                    >
                      {t("serviceActions.detail.updateInfo")}
                    </Button>
                  )}
                {isApproved && (
                  <Button
                    className="ant-btn btn-invoice"
                    onClick={() => handleGenerateInvoice()}
                  >
                    {t("serviceActions.tableList.createInvoice")}
                  </Button>
                )}
                {status === "invoiced" &&
                  canDisplayEmailButtons &&
                  !invoiceSendStatus && (
                    <>
                      <Button
                        className="ant-btn download-invoice"
                        onClick={() => handleSendInvoice("customer")}
                      >
                        <FeatherIcon icon="mail" size={14} />
                        &nbsp; Poslať Zákazníkovi
                      </Button>
                    </>
                  )}
                {(status === "invoiced" || status === "sent") &&
                  canDisplayEmailButtons && (
                    <>
                      <Button
                        className="ant-btn download-invoice"
                        onClick={() => handleSendInvoice("internal")}
                      >
                        <FeatherIcon icon="mail" size={14} />
                        &nbsp; Poslať Ekonómke
                      </Button>
                      &nbsp;
                      <Button
                        className="ant-btn download-invoice"
                        onClick={() => handleDownloadInvoice()}
                      >
                        <FeatherIcon icon="download" size={14} />
                        &nbsp;
                        {t("serviceActions.tableList.invoice")}
                      </Button>
                    </>
                  )}
                {status === "invoiced" && !canDisplayEmailButtons && (
                  <div>{emailDisableMessage}</div>
                )}
              </>
            }
          >
            <Row gutter={30}>
              <Col md={4} xs={24} className="mb-25">
                <Form.Item
                  name="mileage"
                  label={t("services.mileage")}
                  className="small-input"
                  initialValue={data?.mileage}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col md={4} xs={24} className="mb-25">
                <Form.Item
                  name="status"
                  label={t("serviceActions.tableList.status")}
                  className="small-input"
                >
                  {statusName}
                </Form.Item>
              </Col>
              <Col md={5} xs={24} className="mb-25">
                <Form.Item
                  name="date"
                  label={t("services.date")}
                  className="small-input"
                  initialValue={formatSQLDate(data?.date)}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              {displayDeclinedInfoMessage && (
                <Col md={6} xs={24} className="mb-25">
                  <div
                    className="alert alert-danger"
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <FeatherIcon icon="alert-circle" size={14} color="red" />
                    &nbsp; Objednávka bola zamietnutá
                  </div>
                </Col>
              )}
              {(!displayDeclinedInfoMessage ||
                (displayDeclinedInfoMessage &&
                  status === "declined" &&
                  data?.ayvens_order_status === "declined")) && (
                <Col md={5} xs={24} className="mb-25">
                  <Form.Item
                    name="authorization_code"
                    label={t("serviceActions.detail.authorizationCode")}
                    className="small-input"
                    initialValue={data?.authorization_code}
                  >
                    <Input
                      disabled={!canSetCode}
                      onChange={(e) => {
                        setCode(e.target.value);
                        if (e.target.value) {
                          setCanApprove(true);
                        } else {
                          setCanApprove(false);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              )}
              {isApproved && (
                <>
                  <Col md={5} xs={24} className="mb-25">
                    <Form.Item
                      name="invoice_issue_date"
                      id="invoice_issue_date"
                      label={t("services.invoiceIssueDate")}
                      className="small-input"
                      initialValue={moment(data?.date)}
                    >
                      <DatePicker
                        format={dateFormat}
                        onChange={(date) => handleIssueDateChange(date)}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={5} xs={24} className="mb-25">
                    <Form.Item
                      name="payment_type"
                      id="payment_type"
                      label="Typ platby"
                      className="small-input"
                      initialValue={data?.payment_type}
                    >
                      <SelectPaymentType paymentType={setPaymentType} />
                    </Form.Item>
                  </Col>
                </>
              )}
              {status === "invoiced" && (
                <>
                  <Col md={5} xs={24} className="mb-25">
                    <Form.Item
                      name="invoice_issue_date"
                      label={t("services.invoiceIssueDate")}
                      className="small-input"
                      initialValue={formatSQLDate(data?.invoice_issue_date)}
                    >
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col md={5} xs={24} className="mb-25">
                    <Form.Item label="Typ platby" className="small-input">
                      {data?.payment_type && data?.payment_type === "bank"
                        ? "Banka"
                        : "Hotovosť"}
                    </Form.Item>
                  </Col>
                  <Col md={10} xs={24} className="mb-25">
                    {invoiceSendStatus && (
                      <>
                        <div className="invoiceSendStatus">
                          Faktúra bola zaslaná zákazníkovi
                        </div>
                      </>
                    )}
                    {invoiceSendStatusEcon && (
                      <>
                        <div className="invoiceSendStatus">
                          Faktúra bola zaslaná ekonómke
                        </div>
                      </>
                    )}
                  </Col>
                </>
              )}
              {status === "sent" && (
                <>
                  <Col md={5} xs={24} className="mb-25">
                    <Form.Item
                      name="invoice_issue_date"
                      label={t("services.invoiceIssueDate")}
                      className="small-input"
                      initialValue={formatSQLDate(data?.invoice_issue_date)}
                    >
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col md={5} xs={24} className="mb-25">
                    <Form.Item label="Typ platby" className="small-input">
                      {data?.payment_type && data?.payment_type === "bank"
                        ? "Banka"
                        : "Hotovosť"}
                    </Form.Item>
                  </Col>
                  <Col md={10} xs={24} className="mb-25">
                    {invoiceSendStatus && (
                      <>
                        <div className="invoiceSendStatus">
                          Faktúra bola zaslaná zákazníkovi
                        </div>
                      </>
                    )}
                    {invoiceSendStatusEcon && (
                      <>
                        <div className="invoiceSendStatus">
                          Faktúra bola zaslaná ekonómke
                        </div>
                      </>
                    )}
                  </Col>
                </>
              )}
            </Row>
            {ayvensVehicleInfo && enableAyvensFunctions && (
              <>
                <Row gutter={16} style={{ marginBottom: "20px" }}>
                  {/* Left Column */}
                  <Col md={8} xs={24} className="mb-25">
                    {/* Vehicle Information */}
                    {ayvensVehicleInfo.vehicle && (
                      <Card title="🚗 Vehicle Information" size="small">
                        <div style={{ fontSize: "12px" }}>
                          <div>
                            <strong>Brand:</strong>{" "}
                            {ayvensVehicleInfo.vehicle.brand}
                          </div>
                          <div>
                            <strong>Model:</strong>{" "}
                            {ayvensVehicleInfo.vehicle.model}
                          </div>
                          <div>
                            <strong>Type:</strong>{" "}
                            {ayvensVehicleInfo.vehicle.type}
                          </div>
                          <div>
                            <strong>Licence Plate:</strong>{" "}
                            {ayvensVehicleInfo.vehicle.licencePlate}
                          </div>
                          <div>
                            <strong>VIN Code:</strong>{" "}
                            {ayvensVehicleInfo.vehicle.vinCode}
                          </div>
                          <div>
                            <strong>JATO Code:</strong>{" "}
                            {ayvensVehicleInfo.vehicle.jatoCode}
                          </div>
                          <div>
                            <strong>Registration Date:</strong>{" "}
                            {ayvensVehicleInfo.vehicle.registrationDate
                              ? new Date(
                                  ayvensVehicleInfo.vehicle.registrationDate
                                ).toLocaleDateString()
                              : "N/A"}
                          </div>
                          {ayvensVehicleInfo.vehicle.lastMileage && (
                            <div>
                              <strong>Last Mileage:</strong>{" "}
                              {ayvensVehicleInfo.vehicle.lastMileage.mileAge} km
                              <br />
                              <small>
                                (as of{" "}
                                {new Date(
                                  ayvensVehicleInfo.vehicle.lastMileage.date
                                ).toLocaleDateString()}
                                )
                              </small>
                            </div>
                          )}
                        </div>
                      </Card>
                    )}
                  </Col>

                  {/* Middle Column */}
                  <Col md={8} xs={24} className="mb-25">
                    {/* Contract Information */}
                    {ayvensVehicleInfo.contract && (
                      <Card
                        title="📋 Contract Information"
                        size="small"
                        style={{ marginBottom: "16px" }}
                      >
                        <div style={{ fontSize: "12px" }}>
                          <div>
                            <strong>Contract Number:</strong>{" "}
                            {ayvensVehicleInfo.contract.contractNumber}
                          </div>
                          <div>
                            <strong>Contract Mileage:</strong>{" "}
                            {ayvensVehicleInfo.contract.contractMileage} km
                          </div>
                          <div>
                            <strong>Auto Approval Denied:</strong>{" "}
                            {ayvensVehicleInfo.contract.denyAutomaticApproval
                              ? "Yes"
                              : "No"}
                          </div>
                          {ayvensVehicleInfo.contract
                            .denyAutomaticApprovalReason && (
                            <div>
                              <strong>Denial Reason:</strong>{" "}
                              {
                                ayvensVehicleInfo.contract
                                  .denyAutomaticApprovalReason
                              }
                            </div>
                          )}
                        </div>
                      </Card>
                    )}

                    {/* Service Conditions */}
                    <Card title="🔧 Service Conditions" size="small">
                      <div style={{ fontSize: "12px" }}>
                        {ayvensVehicleInfo.serviceConditions ? (
                          <div>
                            {JSON.stringify(
                              ayvensVehicleInfo.serviceConditions
                            )}
                          </div>
                        ) : (
                          <div>No specific service conditions</div>
                        )}
                      </div>
                    </Card>
                  </Col>

                  {/* Right Column */}
                  <Col md={8} xs={24} className="mb-25">
                    {/* Tire Information */}
                    {ayvensVehicleInfo.tireInfo && (
                      <Card
                        title="🛞 Tire Information"
                        size="small"
                        style={{ marginBottom: "16px" }}
                      >
                        <div style={{ fontSize: "12px" }}>
                          {ayvensVehicleInfo.tireInfo.tireSummer && (
                            <div>
                              <strong>Summer Tires:</strong>{" "}
                              {ayvensVehicleInfo.tireInfo.tireSummer.category} -{" "}
                              {ayvensVehicleInfo.tireInfo.tireSummer.size}
                            </div>
                          )}
                          {ayvensVehicleInfo.tireInfo.tireWinter && (
                            <div>
                              <strong>Winter Tires:</strong>{" "}
                              {ayvensVehicleInfo.tireInfo.tireWinter.category} -{" "}
                              {ayvensVehicleInfo.tireInfo.tireWinter.size}
                            </div>
                          )}
                          {ayvensVehicleInfo.tireInfo.tireRims && (
                            <>
                              <div>
                                <strong>Rim Category:</strong>{" "}
                                {ayvensVehicleInfo.tireInfo.tireRims.category ||
                                  "N/A"}
                              </div>
                              <div>
                                <strong>Rim Size:</strong>{" "}
                                {ayvensVehicleInfo.tireInfo.tireRims.size ||
                                  "N/A"}
                              </div>
                            </>
                          )}
                          {ayvensVehicleInfo.tireInfo.note && (
                            <div>
                              <strong>Note:</strong>{" "}
                              {ayvensVehicleInfo.tireInfo.note}
                            </div>
                          )}
                          {ayvensVehicleInfo.tireInfo.serviceSpecOptions && (
                            <div>
                              <strong>Service Options:</strong>{" "}
                              {ayvensVehicleInfo.tireInfo.serviceSpecOptions}
                            </div>
                          )}
                        </div>
                      </Card>
                    )}

                    {/* Allowed Car Service Info */}
                    <Card title="✅ Service Restrictions" size="small">
                      <div style={{ fontSize: "12px" }}>
                        {ayvensVehicleInfo.allowedCarServiceInfo ? (
                          <div>
                            {JSON.stringify(
                              ayvensVehicleInfo.allowedCarServiceInfo
                            )}
                          </div>
                        ) : (
                          <div>No additional service restrictions</div>
                        )}
                      </div>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
            <Row gutter={30}>
              <Col md={24} xs={24} className="mb-25">
                <Form.Item name="note" initialValue={data?.note}>
                  <Input.TextArea
                    placeholder={t("serviceActions.detail.invoice.noteHint")}
                    disabled={!canSetCode}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Form>
      </BasicFormWrapper>
    </>
  );
};

export default InfoFormRight;
